import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useTranslation } from '@crehana/i18n';
import { SearchField } from "../../../../SearchField";
import { Dropdown, DropdownContent, DropdownFilterButton, DropdownTextList } from "../../../Dropdown";
import locales from "../../i18n";
import { OPTIONS } from "./constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FilterHeader = function FilterHeader(_ref) {
  var onSearch = _ref.onSearch,
    setFocusEvent = _ref.setFocusEvent,
    sortItems = _ref.sortItems;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var t = locales[languageCode];
  var orderList = OPTIONS.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      label: t[item.label]
    });
  });
  var handleSearch = function handleSearch(event) {
    var value = event.target.value;
    onSearch(value);
  };
  var onFocus = function onFocus() {
    setFocusEvent(true);
  };
  var intlCategories = orderList.map(function (itemSelect) {
    return {
      label: itemSelect.label,
      value: itemSelect.value
    };
  });
  var handleSort = function handleSort(sortValue) {
    sortItems(String(sortValue));
  };
  var clearSearch = function clearSearch() {
    onSearch('');
  };
  var handleClearOrder = function handleClearOrder() {
    sortItems('');
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-w-full tw-justify-between tw-items-center tw-mt-1.6",
    children: [/*#__PURE__*/_jsx(SearchField, {
      label: '',
      placeholder: t.ATTRIBUTES_PLACEHOLDER_SEARCH,
      onChange: handleSearch,
      onFocus: onFocus,
      onClearButtonClick: clearSearch
    }), /*#__PURE__*/_jsx("div", {
      className: "tw-relative",
      children: /*#__PURE__*/_jsxs(Dropdown, {
        children: [/*#__PURE__*/_jsx(DropdownFilterButton, {
          disabled: false,
          multiselect: false,
          onClear: handleClearOrder,
          children: t.DASHBOARD_USERS_FILTER_ORDER
        }), /*#__PURE__*/_jsx(DropdownContent, {
          children: /*#__PURE__*/_jsx(DropdownTextList, {
            items: intlCategories,
            multiselect: false,
            onSelect: handleSort
          })
        })]
      })
    })]
  });
};